/**
 * Space between a calendar row's coloured bar and its text: the exercise name,
 * its subheader and saving shimmer, and the recurring section header.
 *
 * TV Mode keeps a tighter inset; its row metrics are tuned separately (the
 * TV_* constants in DraggableContent).
 */

export const TEXT_INSET = 10;
export const TV_TEXT_INSET = 7;

/**
 * @param {boolean} isTvMode whether the calendar is in TV Mode.
 * @returns {number} the inset in px.
 */
export const getItemTextInset = (isTvMode) => (isTvMode ? TV_TEXT_INSET : TEXT_INSET);
